const CEO_PROFILE = {
  key: 'ceo',
  label: 'CEO',
  criticalLow: 12,
  normalLow: 19,
  normalHigh: 21.5,
  labels: ['<12 qt', '<19 qt', '19-21.5 qt', '>21.5 qt']
};

const NEO_PROFILE = {
  key: 'neo',
  label: 'NEO',
  criticalLow: 14,
  normalLow: 16,
  normalHigh: 20,
  labels: ['<14 qt', '<16 qt', '16-20 qt', '>20 qt']
};

export const getOilQuantityProfile = aircraftType => {
  const type = String(aircraftType || '').toUpperCase();
  return type.includes('271N') || type.includes('NEO') ? NEO_PROFILE : CEO_PROFILE;
};

export const getOilQuantityAssessment = (value, aircraftType) => {
  if (value === '' || value === null || value === undefined) {
    return { status: 'empty', message: '', acceptable: false };
  }

  const quantity = Number.parseFloat(String(value).replace(',', '.'));
  if (!Number.isFinite(quantity)) {
    return { status: 'invalid', message: 'Enter a valid oil quantity.', acceptable: false };
  }

  const profile = getOilQuantityProfile(aircraftType);
  if (quantity < profile.criticalLow) {
    return {
      status: 'critical-low',
      message: 'The entered value is below the minimum limit. Maintenance action is required.',
      acceptable: false
    };
  }
  if (quantity < profile.normalLow) {
    return {
      status: 'caution-low',
      message: 'The entered value is within the limits. No action required.',
      acceptable: true
    };
  }
  if (quantity <= profile.normalHigh) {
    return {
      status: 'normal',
      message: 'The entered value is within the limits. No action required.',
      acceptable: true
    };
  }
  return {
    status: 'caution-high',
    message: 'The entered value is above the normal range. Verify the entered quantity.',
    acceptable: true
  };
};

export const isOilQuantityAcceptable = (value, aircraftType, maximum) => {
  const quantity = Number.parseFloat(String(value).replace(',', '.'));
  if (!Number.isFinite(quantity) || quantity > maximum) return false;
  return getOilQuantityAssessment(quantity, aircraftType).acceptable;
};
